export const ERROR_ENTITY = {
  Campaign: 'campaign',
  AssetGroup: 'assetGroup',
  CampaignLocation: 'campaignLocation',
  CampaignRadius: 'campaignRadius',
  CampaignNegativeLocation: 'campaignNegativeLocation',
  CampaignLocationIntent: 'campaignLocationIntent',
  CampaignDayTimeCriterion: 'campaignDayTimeCriterion',
  CampaignNegativeWebpage: 'campaignNegativeWebpage',
  AudienceGroupAssetGroupAssociation: 'audienceGroupAssetGroupAssociation',
  BrandListAssociation: 'brandListAssociation',
};
